import { render, staticRenderFns } from "./realtime-manage.vue?vue&type=template&id=0e4863b8"
import script from "./realtime-manage.vue?vue&type=script&lang=js"
export * from "./realtime-manage.vue?vue&type=script&lang=js"
import style0 from "./realtime-manage.vue?vue&type=style&index=0&id=0e4863b8&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports